export default {"src":"/_next/static/media/waylay-integration.6c3b3737.gif","height":445,"width":1039,"blurWidth":0,"blurHeight":0};